import {ErrorHandler, Injectable, Injector} from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

    constructor(private injector: Injector,
                private translate: TranslateService) {
    }

    handleError(error: any) {
        if(typeof error === "function"){
            console.log(typeof error, " -typeof error");
            console.error(error);
        }
        let message = '';
        if(error.status == 401 || error.statusCode == 401){
            message = error.message
        }
        if(error.message.indexOf("Unknown")!= -1){
            return false
        }
        if (typeof error.error?.message == "string") {
            return error.error.message;
        }

        if (error.error) {
            return JSON.parse(error.error).message;
        } else {
            switch (error.status) {
                case 500:
                case 400:
                    message = JSON.parse(error.error).message || error.message;
                    break;
                case 403:
                    message = "Access denied";
                    break;
                case 404:
                    message = this.translate.instant('error.something_incorrect');
                    break;
                default:
                    message = "Unexpected exception";
            }
        }
        return message;
    }
}
